export default __webpack_public_path__ + "static/example-golf-box-0966e7f74fbb31888ba51aa9ef1480a7.svg";